import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import logo from '../../..../../../../public/assets/logo.png';
import React from 'react';
import { UserTick } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
import { PrimaryButon } from '../../components/common/button/PrimaryButon';
import { black400 } from '../../constants/color';
import { centered } from '../freelancer/account/style';
export const EmailVerificationPage = () => {
    const navigate = useNavigate();
    return (_jsx(Box, { sx: { ...centered, height: '100vh' }, children: _jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '550px',
                textAlign: 'center'
            }, children: [_jsx("img", { src: logo, alt: '', style: { width: 150, height: "auto" } }), _jsx(UserTick, { style: { width: '50px', height: '50px', marginTop: '45px' } }), _jsx(Typography, { fontSize: '28px', fontWeight: 550, mt: 2, color: '#000000', children: "Your email verification is successful" }), _jsx(Typography, { variant: 'subtitle1', color: black400, children: "Please proceed to Login" }), _jsx(Box, { px: 3, width: '70%', children: _jsx(PrimaryButon, { onClick: () => navigate('/login'), mt: 25, children: "Log in" }) })] }) }));
};
